import angular from 'angular'
import RbMap from './rb-map/rb-map.module'

import RbGoogle from './rb-google.service'
import rbCoordinates from './coordinates/rb-coordinates.cmp'
import rbInputCoordinates from './coordinates/rb-input-coordinates.cmp'

import './rb-map.scss'

export default angular.module('rb.google', [ RbMap.name ])
  .service('RbGoogle', RbGoogle)
  .component('rbCoordinates', rbCoordinates)
  .component('rbInputCoordinates', rbInputCoordinates)
